import { Play, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/api";

const PLATFORM = { youtube: "YouTube", youtube_short: "YouTube Shorts", instagram: "Instagram Reel", facebook: "Facebook", other: "Video" };

export function withUtm(v) {
  try {
    const u = new URL(v.url);
    if (v.utm_campaign) u.searchParams.set("utm_campaign", v.utm_campaign);
    return u.toString();
  } catch { return v.url; }
}

export function VideoCard({ v, onPlay, movie }) {
  const vertical = v.platform === "youtube_short" || v.platform === "instagram";
  const play = () => {
    trackEvent("video_click", { title_id: v.title_ids?.[0] });
    if (v.embed_url && onPlay) onPlay(v);
    else window.open(withUtm(v), "_blank", "noopener");
  };
  return (
    <article data-testid={`video-card-${v.id}`} className="group w-[260px] shrink-0 snap-start overflow-hidden rounded-2xl border border-white/5 bg-[#12121A] sm:w-[300px]">
      <button onClick={play} className={`relative block w-full overflow-hidden bg-black ${vertical ? "aspect-[4/5]" : "aspect-video"}`} aria-label={`Play ${v.title}`}>
        {v.thumbnail ? <img src={v.thumbnail} alt={v.title} loading="lazy" className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105" />
          : <div className="h-full w-full bg-gradient-to-br from-purple-900/60 to-amber-700/30" />}
        <span className="absolute inset-0 flex items-center justify-center"><span className="rounded-full bg-amber-400 p-4 text-black shadow-xl transition-transform group-hover:scale-110"><Play className="h-5 w-5 fill-black" /></span></span>
        <span className="absolute left-3 top-3 rounded-full bg-black/70 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-purple-300">{PLATFORM[v.platform]}</span>
      </button>
      <div className="p-4">
        <h3 className="line-clamp-2 font-semibold">{v.title}</h3>
        {v.description && <p className="mt-1 line-clamp-2 text-xs text-slate-400">{v.description}</p>}
        <div className="mt-3 flex items-center justify-between">
          <button data-testid={`watch-video-${v.id}`} onClick={play} className="text-xs font-bold uppercase tracking-wider text-amber-400 hover:text-amber-300">Watch Video</button>
          {movie ? <Link to={movie} className="flex items-center gap-1 text-xs text-slate-400 hover:text-white">Movie page <ExternalLink className="h-3 w-3" /></Link> : null}
        </div>
      </div>
    </article>
  );
}

export function VideoPlayer({ v, onClose }) {
  if (!v) return null;
  const vertical = v.platform === "youtube_short" || v.platform === "instagram";
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" onClick={onClose} data-testid="video-player">
      <div className={`w-full ${vertical ? "max-w-sm aspect-[9/16]" : "max-w-4xl aspect-video"}`} onClick={(e) => e.stopPropagation()}>
        <iframe title={v.title} src={`${v.embed_url}${v.embed_url.includes("youtube") ? "?autoplay=1&rel=0" : ""}`} className="h-full w-full rounded-xl" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        <div className="mt-3 flex justify-between text-sm">
          <a href={withUtm(v)} target="_blank" rel="noopener noreferrer" className="text-amber-400">Open on {PLATFORM[v.platform]}</a>
          <button onClick={onClose} data-testid="video-player-close" className="text-slate-300">Close</button>
        </div>
      </div>
    </div>
  );
}
